import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "@nuxtjs/composition-api";

interface Props {
    popupVisible: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GymSignInPopup',
  props: {
    popupVisible: { type: Boolean, default: false }
  },
  emits: ['onPopupClose'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { popupVisible: boolean };





const {
    popupVisible
} = toRefs(props);

const handleCloseSignInPopup = () => {
    $emit('onPopupClose');
}

return { __sfc: true,props, $emit, popupVisible, handleCloseSignInPopup }
}

})